export const types = {
	request: '[Chains] Request Chains',
	chains: '[Chains] Request Success',
	error: '[Chains] Request Error',
}
